import { Shield } from 'lucide-react';

export default function AccessGate() {
  return (
    <div
      data-testid="access-gate"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: '#0A0A0F', fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      <div className="max-w-md w-full text-center">
        {/* APEX Verity logo */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-lg bg-[#6366F1]/15 border border-[#6366F1]/30 flex items-center justify-center">
            <Shield size={20} className="text-[#6366F1]" />
          </div>
          <div className="text-left">
            <div
              className="text-xl font-bold text-[#F8FAFC] tracking-tight"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              APEX VERITY
            </div>
            <div className="text-[9px] font-mono text-[#475569] uppercase tracking-[0.18em] -mt-0.5">
              Temporal AI Governance
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="text-xl text-[#F8FAFC] font-light mb-3 leading-relaxed">
          This platform is in private preview.
        </div>
        <div className="text-sm text-[#64748B] mb-10 leading-relaxed">
          Access is granted to design partners and qualified institutional buyers. Contact us to request a preview key.
        </div>

        {/* CTA */}
        <a
          data-testid="access-gate-contact-btn"
          href="https://apexverity.io/contact"
          className="inline-block bg-[#6366F1] hover:bg-[#818cf8] text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors"
        >
          Request access →
        </a>

        {/* Footnote */}
        <div className="mt-12 text-[10px] font-mono text-[#475569] uppercase tracking-[0.15em]">
          APEX Verity · Zurich · Private Preview
        </div>
      </div>
    </div>
  );
}
